import React from 'react'
import LayoutMain from '../../../components/Layout/Main/Main'
import LeftSidedImageCopyItemCollection from "../../../Partials/LeftSidedImageCopyItem/collection";
import ProjectImageDatePageCollection from "../../../Partials/ProjectImageDetailPage/Collection";
import BannerWithButton from "../../../Partials/BannerWithButton/index";

const leftSidedImageCopyItemCollectionData = [
    {
        description : [
            'This Balmain courtyard is a carefully managed combination of materials that allow the new and old structures to sit comfortably together and brings the whole garden up to date. The cedar bench top provides a warmth to the outdoor space which is dominated by the restrained colours of the walling and flooring. While the consistent mid green colour of the planting provides structure to this garden the combination of varying leaf shapes and textures provides the depth and interest.',
            'An offset layout to the bench seating provides a solution for depth in the garden to introduce screening to create a very private and relaxing courtyard in this urban environment.'
        ],
        descriptionContent : (
            <>
                <p>
                    <span className="line">
                    <b>Services Undertaken</b>
                    <br/>Landscape Architecture
                    <br/>Construction
                    <br/>Ongoing Maintenance
                    </span>

                    <b>Design Features</b>
                    <br/>Contemporary
                    <br/>Entertainer
                    <br/>Courtyard/Rooftop
                </p>
            </>
        ),
        image : '../images/projects/balmain-3.jpg',
        title : 'Balmain'
    }
]

const projectImageDetailPageCollectionData = [
    {
        dataId : 'a1',
        image : '../images/projects/balmain-1.jpg'
    },
    
    {
        dataId : 'a4',
        image : '../images/projects/balmain-2.jpg'
    },
    {
        dataId : 'a8',
        image : '../images/projects/balmain-3.jpg'
    },
    {
        dataId : 'a2',
        image : '../images/projects/balmain-4.jpg'
    },
    {
        dataId : 'a3',
        image : '../images/projects/balmain-5.jpg'
    },
    {
        dataId : 'a3',
        image : '../images/projects/balmain-6.jpg'
    },
    {
        dataId : 'a2',
        image : '../images/projects/balmain-7.jpg'
    },
    {
        dataId : 'a3',
        image : '../images/projects/balmain-8.jpg'
    },
    {
        dataId : 'a5',
        image : '../images/projects/balmain-9.jpg'
    },
  ]
const PageBalMain = () => {
  return (
    <LayoutMain>
    <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className="pb-100">
        <div className="container-3">
          <div className="row">
            <ProjectImageDatePageCollection
              data={projectImageDetailPageCollectionData}
            />
          </div>
        </div>
      </section>
      <BannerWithButton link="/consultation" title="Book A Consultation"/>

    </LayoutMain>
  )
}

export default PageBalMain